import i18n from '../../../i18n';
import { entityText } from '../../../i18n/entityText';
import { formatNumber } from '../../../i18n/format';

// Shared presentation helpers for lootbox chests, keys and their rewards.
// Chest contents (GET /v1/lootbox/contents) use { rewardType, rewardValue, moduleName, moduleImageUrl };
// an open result (POST /v1/lootbox/chests/{id}/open) uses { rewardType, value, characterModuleImageUrl, contentId }.

export const RARITY_COLOR = {
  GREEN:  '#3cdc6f',
  BLUE:   '#4ecbff',
  PURPLE: '#c66cff',
  GOLD:   '#ffd13a',
};

// Подписи редкостей — shared/utils/gameLabels.js (rarityLabel), переводятся через i18n

export const rarityColor = (rarity, fallback = '#c66cff') => RARITY_COLOR[rarity] || fallback;

const formatAmount = (rewardType, value) => {
  if (value == null) return '';
  const n = parseFloat(value);
  if (Number.isNaN(n)) return '';
  // GRAM keeps its fraction (0.5), coins are grouped (5,000)
  return rewardType === 'TON' ? String(n) : formatNumber(n);
};

/** Normalises a chest content row or an open result into { type, name, amount, imageUrl }. */
export function describeReward(reward, t = i18n.t.bind(i18n)) {
  if (!reward) return { type: null, name: '', amount: '', imageUrl: null };
  const type = reward.rewardType;
  const value = reward.rewardValue ?? reward.value;
  const moduleImage = reward.moduleImageUrl || reward.characterModuleImageUrl || null;

  switch (type) {
    case 'COINS':
      return { type, name: t('reward.coins', 'Coins'), amount: formatAmount(type, value), imageUrl: '/coin_icon.png' };
    case 'TON':
      return { type, name: 'GRAM', amount: formatAmount(type, value), imageUrl: '/gram.png' };
    case 'CHARACTER_MODULE':
      return {
        type,
        name: reward.moduleName
          ? entityText(t, 'character_module', reward.moduleId || reward.characterModuleId, 'name', reward.moduleName)
          : t('reward.module', 'Module'),
        amount: '×1',
        imageUrl: moduleImage,
      };
    default:
      return { type, name: type || t('reward.generic', 'Reward'), amount: formatAmount(type, value), imageUrl: null };
  }
}

/** Is `content` (a chest content row) the reward described by `drop` (an open result)? */
export function isSameReward(content, drop) {
  if (!content || !drop) return false;
  if (drop.contentId) return content.id === drop.contentId;
  // Fallback for an older backend without contentId
  if (content.rewardType !== drop.rewardType) return false;
  if (drop.rewardType === 'CHARACTER_MODULE') {
    return !drop.characterModuleImageUrl || content.moduleImageUrl === drop.characterModuleImageUrl;
  }
  return parseFloat(content.rewardValue) === parseFloat(drop.value);
}
